import { atom } from 'recoil';

export const rateManagementUploadState = atom({
  key: 'RateManagement/UploadState',
  default: {
    isUploading: false,
    isUploaded: false,
    isUploadFailed: false,
  },
});

export const rateManagementCancelOrderState = atom({
  key: 'RateManagement/CancelOrderState',
  default: {
    isCanceling: false,
    isCanceled: false,
    isCancelFailed: false,
  },
});

export const rateManagementSendOrderState = atom({
  key: 'RateManagement/SendOrderState',
  default: {
    isSending: false,
    isSent: false,
    isSendFailed: false,
  },
});

export const rateManagementDownloadSpreadsheetState = atom({
  key: 'RateManagement/DownloadOrderState',
  default: {
    isDownloading: false,
    isDownloaded: false,
    isDownloadFailed: false,
  },
});

export const rateManagementCancelledOrderState = atom({
  key: 'RateManagement/CancelledOrderState',
  default: {
    wasCancelled: false,
  },
});

export const rateManagementSentOrderState = atom({
  key: 'RateManagement/SentOrderState',
  default: {
    wasSent: false,
  },
});

export const rateManagementUploadedOrderState = atom({
  key: 'RateManagement/UploadedOrderState',
  default: {
    wasUploaded: false,
  },
});
